const piedata = [
    {
        "id": "css",
        "label": "css",
        "value": 335,
        "color": "hsl(358, 70%, 50%)"
    },
    {
        "id": "php",
        "label": "php",
        "value": 350,
        "color": "hsl(252, 70%, 50%)"
    },
    {
        "id": "elixir",
        "label": "elixir",
        "value": 228,
        "color": "hsl(120, 70%, 50%)"
    },
    {
        "id": "java",
        "label": "java",
        "value": 536,
        "color": "hsl(153, 70%, 50%)"
    },
    {
        "id": "make",
        "label": "make",
        "value": 418,
        "color": "hsl(339, 70%, 50%)"
    }
]
export default piedata;